













/* eslint-disable no-param-reassign */
import {
	defineComponent,
} from '@vue/composition-api';

const ACTIVE_CLASS = 'height-active';

function collapse(element: HTMLElement) {
	element.style.height = '0';
	element.style.paddingTop = '0';
	element.style.paddingBottom = '0';
}

export default defineComponent({
	setup(props, ctx) {
		let tid = -1;
		const clearAnimation = () => {
			window.cancelAnimationFrame(tid);
		};
		const beforeEnter = () => {
			clearAnimation();
		};
		const beforeLeave = () => {
			clearAnimation();
		};
		const enter = (element: HTMLElement, done: () => void) => {
			const { width, paddingTop, paddingBottom } = window.getComputedStyle(element);

			element.style.width = width;
			element.style.position = 'absolute';
			element.style.visibility = 'hidden';
			element.style.height = 'auto';
			element.style.transform = 'scaleY(0)';

			tid = window.requestAnimationFrame(() => {
				const { height } = window.getComputedStyle(element);

				element.style.width = '';
				element.style.position = '';
				element.style.visibility = '';

				collapse(element);

				tid = window.requestAnimationFrame(() => {
					// Force repaint to make sure the animation is triggered correctly.
					window.getComputedStyle(element).height; /* eslint-disable-line no-unused-expressions */

					element.classList.add(ACTIVE_CLASS);

					// Trigger the animation.
					// We use `requestAnimationFrame` because we need
					// to make sure the browser has finished
					// painting after setting the `height`
					// to `0` in the line above.
					tid = window.requestAnimationFrame(() => {
						element.style.height = height;
						element.style.paddingTop = paddingTop;
						element.style.paddingBottom = paddingBottom;
						element.style.transform = 'scaleY(1)';

						const onEnd = () => {
							done();
							element.removeEventListener('transitionend', onEnd);
						};

						element.addEventListener('transitionend', onEnd);
					});
				});
			});
		};
		const afterEnter = (element: HTMLElement) => {
			clearAnimation();
			element.classList.remove(ACTIVE_CLASS);
			element.style.height = 'auto';
			element.style.paddingTop = '';
			element.style.paddingBottom = '';
			element.style.transform = '';
			ctx.emit('after-enter');
		};
		const leave = (element: HTMLElement) => {
			const { height } = window.getComputedStyle(element);
			element.classList.add(ACTIVE_CLASS);

			element.style.height = height;

			// Force repaint to make sure the
			// animation is triggered correctly.
			window.getComputedStyle(element).height; /* eslint-disable-line no-unused-expressions */

			tid = window.requestAnimationFrame(() => {
				collapse(element);
			});
		};

		return {
			beforeEnter,
			enter,
			afterEnter,
			beforeLeave,
			leave,
		};
	},
});
